import PropTypes from "prop-types";

import { priceFormatter } from "helpers/number-formatter";
import { currencyType } from "helpers/currency-type";

const Price = ({ price, currency }) => {
  return (
    <>
      {priceFormatter(price)} {currencyType(currency)}
    </>
  );
};

Price.propTypes = {
  price: PropTypes.any,
  currency: PropTypes.string,
};

export default Price;
